import api from 'app/utils/api';
import { ROLES } from 'app/configs/roles';
import {
  SavedFilterType,
  SavedTransactionFilter,
} from 'app/config/environment/partnerConfig';
import { FilterValues } from 'app/pages/Compliance/Dashboard/pages/transactions/filterHandler';

export interface CreateSavedFilterPayload {
  filterType: SavedFilterType;
  name: string;
  filters: Partial<FilterValues>;
}

export interface UpdateSavedFilterPayload {
  name?: string;
  filters?: Partial<FilterValues>;
}

export class SavedFilterService {
  static createSavedFilter(payload: CreateSavedFilterPayload) {
    return api.post<SavedTransactionFilter>(`/user/saved-filters`, payload);
  }

  static updateSavedFilter(
    filterId: string,
    payload: UpdateSavedFilterPayload
  ) {
    return api.patch<SavedTransactionFilter>(
      `/user/saved-filters/${filterId}`,
      payload
    );
  }

  static deleteSavedFilter(filterId: string) {
    return api.delete<{ success: true }>(`/user/saved-filters/${filterId}`);
  }
}

export class UserService {
  public async validateInvite(inviteCode: string) {
    return api.get(`/user/validate-invite/${inviteCode}`);
  }

  public async createAgentAccount(
    name: string,
    phone: string,
    password: string,
    inviteCode: string
  ) {
    return api.post(`/user/signup`, {
      name,
      phone,
      password,
      inviteCode,
      role: ROLES.AGENT,
    });
  }

  public static createUser(formData: {
    name: string;
    email: string;
    rolesList: string[];
    partnerID: string;
    officeID: string | null;
  }) {
    return api.post('/user/create-user', formData);
  }

  public async userLogin(email: string, password: string) {
    return api.post(`/user/login`, {
      email,
      password,
    });
  }

  public async getUserProfile() {
    return api.get(`/user/profile`);
  }

  public static getRoles(partnerId?: string) {
    const query = partnerId ? `?partnerId=${partnerId}` : '';
    return api.get(`/user/roles/${query}`);
  }

  static async updateUserDataTracker() {
    return api.patch(`/user/data-tracking`);
  }

  public async registerUserFCMToken(token: string, device: string) {
    return api.post(`/user/register-fcm-token`, {
      token,
      device,
    });
  }

  public static searchUsers(query: string, limit: number = 20) {
    return api.get(`/user?q=${encodeURIComponent(query)}&limit=${limit}`);
  }

  public static updateUserRoles(formData: {
    email: string;
    rolesList: string[];
    partnerID: string;
    officeID: string | null;
  }) {
    return api.put('/user/roles', formData);
  }
}
